import { createSlice } from '@reduxjs/toolkit'


const authUserSlice = createSlice({
    name: 'authUser',
    initialState: {
        auth_user: {
            is_logged_in: false,
            user_id: '',
            user_full_name: '',
            user_email: '',
            user_mob_number: '',
            user_type: '',
        }
    },
    reducers: {
        setAuthUser(state, {payload}){
            // console.log('---authUserSlice---setAuthUser---111:', payload)
            state.auth_user.is_logged_in = true;
            state.auth_user.user_id = payload.user_id;
            state.auth_user.user_full_name = payload.user_full_name;
            state.auth_user.user_email = payload.user_email;
            state.auth_user.user_mob_number = payload.user_mob_number;
            state.auth_user.user_type = payload.user_type;
        },

        updateAuthUser(state, {payload}) {
            state.auth_user = { ...payload }
        },

        removeAuthUser(state, {payload}) {
            state.auth_user.is_logged_in = false;
            state.auth_user.user_id = '';
            state.auth_user.user_full_name = '';
            state.auth_user.user_email = '';
            state.auth_user.user_mob_number = '';
            state.auth_user.user_type = '';
        },

        userLogout(state) {
            state.auth_user.is_logged_in = false;
        }

    }
});


export default authUserSlice.reducer;
export const { setAuthUser, updateAuthUser, userLogout } = authUserSlice.actions;
